import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { queryKeys } from '../../queryKeys';

import { ActiveAlertsResponse } from './types';

export function useActiveAlerts<T = ActiveAlertsResponse>({
  select,
  refetchInterval,
}: {
  select?: (data: ActiveAlertsResponse) => T;
  refetchInterval?: number;
}) {
  return useQuery(queryKeys.active(), async () => getActiveAlerts(), {
    ...withError('Unable to get alerts'),
    select,
    refetchInterval,
  });
}

export async function getActiveAlerts() {
  try {
    const { data } = await axios.get<ActiveAlertsResponse>(
      `/observability/alerting/alerts`,
      {
        params: { status: 'active' },
      }
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error);
  }
}
